import moment from "moment";
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import {
    Edit,
    SimpleForm,
    TextInput,
    DateInput,
} from "react-admin";
import { useForm } from 'react-final-form';

import { _clientUserStorage } from "../../utils/storage";

const useStyles = makeStyles(theme => ({
    form: {
        width: "100%",
        "& > div > div > div:first-child": {
            width: "100%",
        }
    },
}));

const CreateComponent = (props) => {
    const classes = useStyles();
    return (
        <Edit {...props} title="Edit" >
            <SimpleForm className={classes.form} redirect={"list"} >
                <Grid container spacing={3}>
                    <Grid item sm={12}>
                        <DateInput label="Date" source="date" fullWidth />
                    </Grid>
                    <Grid item sm={12}>
                        <TextInput label="Messages" source="messages" multiline rows={4} fullWidth />
                    </Grid>
                </Grid>
            </SimpleForm >
        </Edit >
    )
};

export default CreateComponent;
